import React, { Dispatch, SetStateAction, ChangeEvent } from 'react';
import { DropdownField, MenuItem } from '@one-thd/sui-atomic-components';
import { IPHRequest } from '../../../models/purchase-history';

interface ISortBy {
  pHRequest: IPHRequest;
  setPHRequest: Dispatch<SetStateAction<IPHRequest>>;
  handleClose: () => void;
}

export const SortBy = (props: ISortBy) => {
  const { pHRequest, setPHRequest, handleClose } = props;
  return (
    <DropdownField
      label="Sort By"
      value={pHRequest.sortBy}
      onChange={(event: ChangeEvent<HTMLInputElement>) => {
        setPHRequest((prevState: IPHRequest) => {
          return {
            ...prevState,
            sortBy: event.target.value,
          };
        });
        handleClose();
      }}
      fullWidth
    >
      <MenuItem value="salesDate">Date</MenuItem>
      <MenuItem value="orderNumber">Order #</MenuItem>
      <MenuItem value="POJobName">PO/Job Name</MenuItem>
      <MenuItem value="receiptDetails">Receipt #</MenuItem>
      <MenuItem value="orderOrigin">Order Origin</MenuItem>
      <MenuItem value="totalAmount">Total</MenuItem>
      <MenuItem value="accountIdUsed">Payment</MenuItem>
    </DropdownField>
  );
};
